import { getDeviceSize } from '~/utils/device'
import CountersItemV2 from '~/components/Molecules/CountersItem-v2/CountersItem-v2.vue'

export default {
  props: {
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    items: {
      type: Object,
    },
  },

  components: {
    hotCarousel: () => import('~/components/Molecules/Carousel/Carousel.vue'),
    hotCountersItemV2: () => import('~/components/Molecules/CountersItem-v2/CountersItem-v2.vue'),
  },

  data() {
    return {
      isMobile: null,
      hasDeviceSize: false,
      countersItem: CountersItemV2,
      swiperOptions: {
        slidesPerView: 1.25,
        spaceBetween: 16,
        allowTouchMove: true,
        slideToClickedSlide: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          414: {
            slidesPerView: 1.75,
          },
          580: {
            slidesPerView: 2.25,
          },
          768: {
            slidesPerView: 3.25,
          },
          1024: {
            slidesPerView: 'auto',
          },
        },
      },
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.resize)
      window.dispatchEvent(new Event('resize'))
    })
  },

  destroyed() {
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    resize(e) {
      this.checkDeviceSize(e, this)
    },

    checkDeviceSize() {
      const device = getDeviceSize()
      if (/mobile(?:\-(?:l|[m]))?/.test(device)) {
        this.isMobile = true
        this.hasDeviceSize = true
      } else {
        this.isMobile = false
        this.hasDeviceSize = true
      }
    },

    sizeCountersDesktop() {
      const locale = this.$i18n.locale
      if (locale === 'ja') {
        return 4
      }

      return 6
    },
  },
}
